<template>
  <div class="page-cont">
    <h1 class="page-title">管理页面</h1>

    <!-- 创建 API Key 表单 -->
    <div class="create-form">
      <el-form :inline="true" :model="createForm" class="demo-form-inline">
        <el-form-item label="所有者 (Owner)">
          <el-input v-model="createForm.Owner" placeholder="请输入所有者名称或备注"></el-input>
        </el-form-item>
        <el-form-item label="过期时间 (expirationTime)">
          <el-date-picker
            v-model="createForm.expirationTime"
            type="datetime"
            placeholder="选择日期时间"
            value-format="yyyy-MM-dd HH:mm:ss"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleCreate" icon="el-icon-plus">创建 API Key</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- API Key 列表 -->
    <div class="list-container">
      <el-table :data="apiKeyList" style="width: 100%" v-loading="loading" border stripe>
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="keyValue" label="API Key" width="180" align="center">
          <template slot-scope="scope">
            <code class="api-key-code">{{ scope.row.keyValue }}</code>
          </template>
        </el-table-column>
        <el-table-column prop="Owner" label="所有者" min-width="120" align="center"></el-table-column>
        <el-table-column prop="numberUsed" label="使用次数" width="100" align="center"></el-table-column>
        <el-table-column prop="expirationTime" label="过期时间" width="200" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.expirationTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="creationTime" label="创建时间" width="200" align="center">
          <template slot-scope="scope">
            {{ formatDate(scope.row.creationTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="120" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.row)"
              icon="el-icon-delete"
            >删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ApikeyPage',
  data() {
    return {
      apiKeyList: [],
      loading: false,
      createForm: {
        Owner: '',
        expirationTime: ''
      }
    };
  },
  mounted() {
    this.fetchApiKeys();
  },
  methods: {
    // 格式化日期
    formatDate(dateStr) {
      if (!dateStr) return '';
      const date = new Date(dateStr);
      // 为了符合 yyyy-MM-dd HH:mm:ss 格式，手动处理
      const y = date.getFullYear();
      const m = String(date.getMonth() + 1).padStart(2, '0');
      const d = String(date.getDate()).padStart(2, '0');
      const h = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const s = String(date.getSeconds()).padStart(2, '0');
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    },

    // 获取所有 API Key
    async fetchApiKeys() {
      const token = localStorage.getItem('token');
      if (!token) {
        this.$message.error('未检测到登录凭证，请重新登录');
        this.$router.push('/login');
        return;
      }

      this.loading = true;
      try {
        const res = await axios.get(`${this.$store.state.ServerAddress}/api/admin/get-all-api-keys`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (res.data.success) {
          this.apiKeyList = res.data.data;
        } else {
          this.$message.error(res.data.msg || '获取列表失败');
        }
      } catch (error) {
        console.error('获取 API Key 列表失败:', error);
        this.handleError(error);
      } finally {
        this.loading = false;
      }
    },

    // 创建 API Key
    async handleCreate() {
      if (!this.createForm.Owner) {
        this.$message.warning('请输入所有者名称');
        return;
      }
      if (!this.createForm.expirationTime) {
        this.$message.warning('请选择过期时间');
        return;
      }

      const token = localStorage.getItem('token');
      try {
        const res = await axios.post(`${this.$store.state.ServerAddress}/api/admin/create-api-key`, {
          Owner: this.createForm.Owner,
          expirationTime: this.createForm.expirationTime
        }, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (res.data.success) {
          this.$message.success('创建成功');
          this.createForm.Owner = '';
          this.createForm.expirationTime = '';
          this.fetchApiKeys(); // 刷新列表
        } else {
          this.$message.error(res.data.msg || '创建失败');
        }
      } catch (error) {
        console.error('创建 API Key 失败:', error);
        this.handleError(error);
      }
    },

    // 删除 API Key
    handleDelete(item) {
      this.$confirm(`确认要删除所有者为 "${item.Owner}" 的 API Key 吗?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const token = localStorage.getItem('token');
        try {
          const res = await axios.post(`${this.$store.state.ServerAddress}/api/admin/delete-api-key`, {
            id: item.id
          }, {
            headers: {
              Authorization: `Bearer ${token}`
            }
          });

          if (res.data.success) {
            this.$message.success('删除成功');
            this.fetchApiKeys(); // 刷新列表
          } else {
            this.$message.error(res.data.msg || '删除失败');
          }
        } catch (error) {
          console.error('删除失败:', error);
          this.handleError(error);
        }
      }).catch(() => {
        this.$message.info('已取消删除');
      });
    },

    // 统一错误处理
    handleError(error) {
      if (error.response && error.response.status === 401) {
        this.$message.error('登录已过期，请重新登录');
        localStorage.removeItem('UserEmail');
        localStorage.removeItem('token');
        this.$router.push('/login');
      } else {
        this.$message.error('请求失败，请稍后重试');
      }
    }
  }
};
</script>

<style scoped>
.page-cont {
  padding: 20px;
  background-color: white;
  min-height: calc(100vh - 20px);
  width: 90vw;
  box-sizing: border-box;
}

.page-title {
  margin-bottom: 30px;
  font-size: 24px;
  color: #303133;
  display: block;
}

.create-form {
  background-color: #f8f9fb;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 30px;
  border: 1px solid #ebeef5;
}

.list-container {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
}

.api-key-code {
  background-color: #f5f7fa;
  padding: 2px 6px;
  border-radius: 4px;
  color: #409eff;
  font-family: monospace;
}
</style>
